import EntityManager from "@/components/EntityManager";
import StatusBadge from "@/components/StatusBadge";
import { inr, today } from "@/lib/format";
import { printDriverRegister } from "@/lib/print";

const exportDriversCsv = (list) => {
  const headers = ["Sl No.", "Name", "Father Name", "Aadhar No.", "Phone", "License No.", "Monthly Salary", "Status"];
  const cell = (v) => { const s = String(v ?? ""); return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s; };
  const lines = [headers.join(",")];
  list.forEach((r, i) => lines.push([i + 1, r.name || "", r.father_name || "", r.aadhar_no || "", r.phone || "", r.license_no || "", r.monthly_salary || 0, r.status || ""].map(cell).join(",")));
  const blob = new Blob([lines.join("\n")], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `ntc-drivers-${today()}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

export default function Drivers() {
  return (
    <EntityManager
      title="Company Drivers"
      subtitle="Driver roster with licenses and payroll."
      endpoint="drivers"
      entityName="Driver"
      selectable
      exportCsv={exportDriversCsv}
      onPrintSelected={(list) => printDriverRegister(list)}
      defaults={{ name: "", father_name: "", aadhar_no: "", phone: "", license_no: "", monthly_salary: 0, status: "Available" }}
      fields={[
        { key: "name", label: "Full name", type: "text", placeholder: "Suresh Kumar" },
        { key: "father_name", label: "Father Name", type: "text", placeholder: "Ram Kumar" },
        { key: "aadhar_no", label: "Aadhar Card No.", type: "text", placeholder: "1234 5678 9012" },
        { key: "phone", label: "Phone", type: "text", placeholder: "+91 98765 43210" },
        { key: "license_no", label: "License no.", type: "text", placeholder: "MH1420110012345" },
        { key: "monthly_salary", label: "Monthly salary (₹)", type: "number", placeholder: "25000" },
        { key: "status", label: "Status", type: "select", options: ["Available", "On Trip", "On Leave"] },
      ]}
      columns={[
        { key: "name", label: "Name" },
        { key: "father_name", label: "Father Name", render: (r) => r.father_name || "—" },
        { key: "aadhar_no", label: "Aadhar No.", render: (r) => r.aadhar_no || "—" },
        { key: "phone", label: "Phone" },
        { key: "license_no", label: "License" },
        { key: "monthly_salary", label: "Salary", align: "right", render: (r) => inr(r.monthly_salary) },
        { key: "status", label: "Status", render: (r) => <StatusBadge status={r.status} /> },
      ]}
    />
  );
}
